<template>
    <span :class="textClass">{{ row.KalanBorc > 0 ? row.KalanBorcStr : '-' || '-' }}</span>
</template>

<script>
export default {
    props:{
        fields:[String,Number],
        row:Object
    },
    computed:{
        textClass(){
            if(this.row.KalanBorc > 0) return 'text-danger font-weight-bolder'
            else return null
        }
    }
}
</script>